define('views/modules/profile/edit/preferences-edit-content-business',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // events
    'services/events/user-events',
    'services/events/calendar-events',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/modules/profile/edit/preferences-edit-form-business',
    'views/parts/alert/alert-list',
    // models
    'models/member/group',
    // templates
    'text!templates/modules/profile/edit/preferences-edit-content.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // events
    UserEvents,
    CalendarEvents,
    // views
    VForm,
    VMenuSaveAction,
    VPreferencesEditFormBusiness,
    VAlertList,
    // models
    MGroup,
    // templates
    TPreferencesEditContent
) {

    var VPreferencesEditContentBusiness = VForm.extend({
        fields: ['units', 'nameFormat', 'emails', 'emailsSupervisor', 'mainGroup', '_mainGroupId', 'customDataDefIds', 'favorite_exercises_type', '_disable_animated_sessions'],
        template: TPreferencesEditContent,

        regions: {
            root: "#preferences-edit-content",
            menu: ".menu-actions",
            form: ".preferences-edit-form",
            alert: '.alert-list'
        },

        initialize: function(opt) {
            this.options = opt;

            this.originalDaysBeforeCalendarItemsAreHiddenValue = this.model.getMainGroup().daysBeforeCalendarItemsAreHidden.toString();

            this.topLevelGroup = new MGroup(this.model.getSupervisorGroup());
            this.topLevelGroup.fetch();

            var model = this.model,
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        onClick: this.onActionClick,
                        onSave: this.onSaveButton,
                        saveText: "Save",
                        radio: false,
                        tooltip: { container: this.regions.root, }
                    }),
                    form: new VPreferencesEditFormBusiness({
                        model: model,
                        group: this.topLevelGroup
                    }),
                    alert: new VAlertList()
                };

            this.listenTo(model, { 'change': this.onModelChange });
            this.listenTo(this.topLevelGroup, { 'change': this.onGroupModelChange });
        },

        render: function() {
            this.originalDaysBeforeCalendarItemsAreHiddenValue = this.model.getMainGroup().daysBeforeCalendarItemsAreHidden.toString();

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form)
                .assign(view.alert, zone.$alert);

            return this;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onGroupModelChange: function() {
            this.view.menu.toggleSaveButton(
                this.topLevelGroup.get('daysBeforeCalendarItemsAreHidden') === this.originalDaysBeforeCalendarItemsAreHiddenValue || this.topLevelGroup.get('daysBeforeCalendarItemsAreHidden') === ""
            );
        },

        onSaveButton: function() {
            var groupModel = this.topLevelGroup;
            this.view.alert.reset();

            if (groupModel.get('daysBeforeCalendarItemsAreHidden') !== this.originalDaysBeforeCalendarItemsAreHiddenValue) {

                if (groupModel.get('daysBeforeCalendarItemsAreHidden') !== false && parseInt(groupModel.get('daysBeforeCalendarItemsAreHidden')) < 0) {
                    this.view.alert.addError('hide-sessions-must-be-positive-number');
                    return false;
                }

                var mainGroup = new MGroup({ _id: this.model.getMainGroupId() });

                User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden = groupModel.get('daysBeforeCalendarItemsAreHidden');

                this.when(mainGroup.save({ daysBeforeCalendarItemsAreHidden: groupModel.get('daysBeforeCalendarItemsAreHidden' )}, { patch: true }))
                    .then(function() {
                        CalendarEvents.daysBeforeCalendarItemsAreHiddenChange();
                    });
            }

            if (! this.model.changedAttributes()) {
                UserEvents.profileUpdate(this.model);
            }
            this.submit();
        },

        onSuccess: function() {
            var master = this.modelMaster,
                model = this.model;
            UserEvents.profileUpdate(model);

            if (model.getMainGroupId() !== master.getMainGroupId()) {
                User.fetch({ force: true });
            }

            this.trigger('back');
        },
    });

    return VPreferencesEditContentBusiness;
});

